export class MultiSelection {
	public ids: number[] = [];
	public all: boolean = false;
	
	constructor(ids: number[], all: boolean) {
		this.ids = [...ids];
		this.all = all;
	}
	
	// Utilise pour transformer l'objet parametre d'URL pour les appel HTTP en mode GET
	// Voir la classe MultiSelectionParamConverter pour la deserialisation cote serveur
	toString() {
		if (!this.ids || this.ids.length == 0)
			return this.all ? "all" : "none";
			
		let list = this.ids.toString();
		
		return (this.all ? "all-" : "") + list;
	}
}